import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import {CheckupResultPage} from '@/pages/CheckupResultPage/CheckupResultPage';
import {CheckupStartPage} from "@/pages/CheckupStartPage/CheckupStartPage";
import {DashboardTabs} from "@/pages/DashboardTabs/DashboardTabs";

export const CheckupRoute = () => {
    const { isAuthenticated } = useAppSelector((state) => state.auth);
    const { passed } = useAppSelector((state) => state.questionnaire);

    if (!isAuthenticated) return <Navigate to="/login" />;

    return passed ? <DashboardTabs /> : <CheckupStartPage />;
};
